<template>
    <div class="bread clearfix">
        <div class="fl mr15">当前位置:</div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="fl">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item,index) in prop" :key="index" :to="{path: item.path}">{{ item.name }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    
</template>

<script>

export default {
    props:['prop'],
    data() {
        return {
            list: ''
        }
    },
    
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
    .bread{
        >div{
            line-height: 40px;
            font-size: 15px;
        }
        .el-breadcrumb__inner.is-link{
            font-weight: 0!important;
        }
    }
</style>

<style lang="scss">
    .bread{
        .el-breadcrumb__item{
            cursor: pointer;
        }
        .el-breadcrumb__inner.is-link{
            font-weight: 500!important;
            cursor: pointer!important;
        }
    }
</style>